import React from "react";

import { Card, CardContent, Link, LinearProgress } from "@material-ui/core";

import OpenInNewIcon from "@material-ui/icons/OpenInNew";

import { seatCountInfoCardStyles } from "./seatCountInfoCardStyles";

export const SeatCountInfoCard = (props) => {
  const classes = seatCountInfoCardStyles();

  return (
    <div style={{ display: "flex" }}>
      <Card variant={"outlined"} className={classes.card}>
        <CardContent className={classes.contentWrapper}>
          <p className={classes.header}>{props.header}</p>
          <div>
            <p className={classes.count}>{props.deviceCount}</p>
            {props.link && (
              <Link href={props.linkUrl} className={classes.link}>
                Request more <OpenInNewIcon />
              </Link>
            )}
            {props.progressBar && (
              <LinearProgress
                variant="determinate"
                value={props.progressValue}
                className={classes.progressBar}
              />
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
